import { requestWithToken } from '../utilities/request';

const getUploadedFileInfo = params => {
  return requestWithToken({
    method: 'GET',
    url: `/api/private/worker_registration_applications/`,
    params,
  });
};

const uploadWorkerRegisterAppPDF = params => {
  return requestWithToken(
    {
      method: 'POST',
      url: `/api/private/worker_registration_applications`,
      headers: { 'content-type': 'multipart/form-data' },
      data: params,
    },
    false
  );
};

const downloadByFileCode = ({ file_code }) => {
  return requestWithToken({
    method: 'GET',
    url: `api/private/static_files/preview`,
    params: { file_code },
    responseType: 'blob',
  });
};

const downloadPDFWorkerRegistration = id => {
  return requestWithToken({
    method: 'GET',
    url: `api/private/worker_registration_applications/${id}/download_file`,
  });
};

export const WorkerRegistrationApplicationService = {
  getUploadedFileInfo,
  uploadWorkerRegisterAppPDF,
  downloadByFileCode,
  downloadPDFWorkerRegistration,
};

export default WorkerRegistrationApplicationService;



// WEBPACK FOOTER //
// ./src/services/WorkerRegistrationApplication.js